import { useEffect, useState } from 'react';

export const BLIND_FORM_ID = 2693;

export const fetchLead = async (leadId) => {
  try {
    const response = await fetch(`/.netlify/functions/get-lead?leadId=${leadId}`);
    return await response.json();
  } catch (e) {
    return null;
  }
};

export function useLeadFormEffect({ marketoFormId }) {
  const [form, setForm] = useState(null);
  const [displayGate, setDisplayGate] = useState(false);
  const [lead, setLead] = useState(null);
  const [polling, setPolling] = useState(false);
  const [leadFailed, setLeadFailed] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (polling) return;

    const getLead = async (leadId) => {
      setPolling(true);
      const data = await fetchLead(leadId);
      if (!data || !data.id) {
        setLeadFailed(true);
        setDisplayGate(true);
        setForm(marketoFormId);
        setPolling(false);
        setReady(true);
      } else {
        setLead(data);
        setForm(BLIND_FORM_ID);
        setDisplayGate(false);
        setPolling(false);
        setReady(true);
      }
    };

    if (typeof window === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);
    const leadId = urlParams.get('leadId');

    if (!leadId || leadFailed) {
      setForm(marketoFormId);
      setDisplayGate(true);
      setReady(true);
    } else if (leadId && !lead && !polling) {
      getLead(leadId);
    }
  }, [marketoFormId, lead, polling, leadFailed]);

  return {
    form,
    displayGate,
    lead,
    leadFailed,
    ready,
  };
}
